export const DEFAULT_SETTINGS = {
  fontSize: 100,
  biggerCursor: false,
  readingGuide: false,
  readingMask: false,
  highContrast: false,
  negativeContrast: false,
  darkMode: false,
  lightMode: false,
  grayscale: false,
  removeImages: false,
  highlightLinks: false,
  highlightHeadings: false,
  dyslexiaFont: false,
  letterSpacing: 0,
  lineHeight: 1.5,
  pauseAnimations: false,
  muteSounds: false,
  stopAutoScroll: false,
  focusMode: false,
  screenReaderHelper: false,
  keyboardNavMode: false,
  saturation: 100,
  brightness: 100,
  underlineLinks: false,
  highlightButtons: false,
  wordSpacing: 0,
};

export const FONT_SIZE_MIN = 50;
export const FONT_SIZE_MAX = 200;
export const FONT_SIZE_STEP = 10;

export const STORAGE_KEY = 'gmbf-a11y-settings';

export const SHORTCUTS = {
  openPanel: { key: 'a', altKey: true, ctrlKey: false },
  closePanel: { key: 'Escape', altKey: false, ctrlKey: false },
  reset: { key: 'r', altKey: true, ctrlKey: false },
  highContrast: { key: 'h', altKey: true, ctrlKey: false },
  darkMode: { key: 'd', altKey: true, ctrlKey: false },
};

export const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
  'area[href]',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
].join(', ');
